/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Enum/SubscriptionCheckoutStatus.php */
export const subscriptionCheckoutStatus = {
	active: 'active',
	requires_action: 'requires_action',
} as const

/** @see backend/nexus/modules/Billing/Enum/SubscriptionCheckoutStatus.php */
export type SubscriptionCheckoutStatus = (typeof subscriptionCheckoutStatus)[keyof typeof subscriptionCheckoutStatus]
